<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="6" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.query" placeholder="Code/Name" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Status">
              <a-select v-model="queryParam.enabledFlag" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="1">Enabled</a-select-option>
                <a-select-option value="0">Disabled</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { query: '', enabledFlag: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('SYS_ROLE_ADD')">New</a-button>
      <!-- <a-button type="dashed" @click="tableOption">{{ optionAlertShow && 'Close' || 'Open' }} alert</a-button> -->
      <a-dropdown v-action:edit v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />Delete</a-menu-item>
          <!-- lock | unlock -->
          <a-menu-item key="2"><a-icon type="lock" />Lock</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          Batch Actions <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('SYS_ROLE_EDIT')">Edit</a>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            More <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-show="record.enabledFlag === '1'">
              <a href="javascript:;" @click="onChangeEnabled(record.id, '0')" :disabled="!$auth('SYS_ROLE_EDIT')">Disable</a>
            </a-menu-item>
            <a-menu-item v-show="record.enabledFlag === '0'">
              <a href="javascript:;" @click="onChangeEnabled(record.id, '1')" :disabled="!$auth('SYS_ROLE_DELETE')">Enable</a>
            </a-menu-item>
            <a-menu-item>
              <a-popconfirm title="Are you sure delete?" @confirm="onDeleteConfirmed(record)" okText="Yes" cancelText="No">
                <a href="javascript:;" :disabled="!$auth('SYS_ROLE_DELETE')">Delete</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
  </div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { toSTablePage } from '@/utils/util'
import { queryRolePage, deleteRole, changeEnabled } from '@/api/api-role'

export default {
  name: 'RoleList',
  components: {
    AInput,
    STable
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { query: '', enabledFlag: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Name',
          dataIndex: 'name'
        },
        {
          title: 'Code',
          dataIndex: 'code'
        },
        {
          title: 'Enabled',
          dataIndex: 'enabledFlag',
          customRender: (value) => value === '1' ? 'Enabled' : 'Disabled'
        },
        {
          title: 'Create Time',
          dataIndex: 'createDate',
          customRender: (value) => this.DateTimeUtil().localString(value)
        },
        {
          title: 'Change Time',
          dataIndex: 'writeDate',
          customRender: (value) => this.DateTimeUtil().localString(value)
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return queryRolePage(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: false,
        rowSelection: null
      },
      optionAlertShow: false
    }
  },
  created () {
    // this.tableOption()
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      deleteRole(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Role delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    // 变更启用状态
    onChangeEnabled (id, flag) {
      const that = this
      changeEnabled(id, { 'enabledFlag': flag }).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Role chang enabled/disabled successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    handleOk () {
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
